import type {Token} from '@sail/engine';
import {assignTokens, toIntent} from '@sail/engine';
import {tokens} from '@sail/tokens/deprecated';
import {DrawerConfig} from '../../components/drawer/DrawerConfig';
import {DialogConfig} from '../../components/dialog/DialogConfig';
import {TooltipConfig} from '../../components/TooltipConfig';
import {BackdropConfig} from '../../components/BackdropConfig';
import {PopoverConfig} from '../../components/popover/PopoverConfig';
import {CounterConfig} from '../../components/Counter';
import {LinkConfig} from '../../components/Link';

// [TODO]: once we control dark mode through CSS these overrides should
// be moved into the actual component CSS instead of being customize calls
// we should also remove the elevation overrides here
export const lightModeComponentOverrides = toIntent([
  DialogConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  DrawerConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  TooltipConfig.customize({}),
  BackdropConfig.customize({}),
  PopoverConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
  CounterConfig.customize({}),
  LinkConfig.customize({
    uses: [assignTokens(tokens, {})],
  }),
]);

export const lightModeTokenOverrides = (): Token.OverrideIntent =>
  assignTokens(tokens, {});
